import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Listens for service worker updates and prompts the user to reload
 * when a new version of the app is available.
 */
export const UpdatePrompt = () => {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({ immediate: true });

  useEffect(() => {
    if (needRefresh) {
      const accepted = window.confirm(
        'A new version of The Stone Circle is available. Reload to update?',
      );
      if (accepted) {
        void updateServiceWorker(true);
      }
    }
  }, [needRefresh, updateServiceWorker]);

  return null;
};
